var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 3.99999C2.77575 3.99999 2.36878 4.16856 2.06873 4.46862C1.76867 4.76868 1.6001 5.17565 1.6001 5.59999V12C1.6001 12.4243 1.76867 12.8313 2.06873 13.1314C2.36878 13.4314 2.77575 13.6 3.2001 13.6H12.8001C13.2244 13.6 13.6314 13.4314 13.9315 13.1314C14.2315 12.8313 14.4001 12.4243 14.4001 12V5.59999C14.4001 5.17565 14.2315 4.76868 13.9315 4.46862C13.6314 4.16856 13.2244 3.99999 12.8001 3.99999H11.5313C11.3191 3.99995 11.1157 3.91563 10.9657 3.76559L10.0689 2.86879C9.76891 2.56871 9.36201 2.40008 8.9377 2.39999H7.0625C6.63819 2.40008 6.23129 2.56871 5.9313 2.86879L5.0345 3.76559C4.8845 3.91563 4.68105 3.99995 4.4689 3.99999H3.2001ZM8.0001 11.2C8.31527 11.2 8.62736 11.1379 8.91854 11.0173C9.20972 10.8967 9.47429 10.7199 9.69715 10.4971C9.92002 10.2742 10.0968 10.0096 10.2174 9.71843C10.338 9.42725 10.4001 9.11517 10.4001 8.79999C10.4001 8.48482 10.338 8.17274 10.2174 7.88155C10.0968 7.59037 9.92002 7.3258 9.69715 7.10294C9.47429 6.88008 9.20972 6.70329 8.91854 6.58268C8.62736 6.46207 8.31527 6.39999 8.0001 6.39999C7.36358 6.39999 6.75313 6.65285 6.30304 7.10294C5.85295 7.55302 5.6001 8.16347 5.6001 8.79999C5.6001 9.43651 5.85295 10.047 6.30304 10.4971C6.75313 10.9471 7.36358 11.2 8.0001 11.2Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.87cae5048cf9e59dfc429c42c30bdeeb.svg";
export { ForwardRef as ReactComponent };